import { useTranslate } from 'react-polyglot';

import { useHostClientContext } from '../../../HostClientProvider/hooks/useHostClientContext';
import { useHostGameContext } from '../../HostGame.context';
import { Sidebar } from '../Sidebar/Sidebar';
import { AnalyticsResultsSidebarLink } from './components/AnalyticsResultsSidebarLink/AnalyticsResultsSidebarLink';
import { DownloadResultsSidebarLink } from './components/DownloadResultsSidebarLink/DownloadResultsSidebarLink';
import { EndSessionButton } from './components/EndSessionButton/EndSessionButton';
import { HideInstructionsSidebarLink } from './components/HideInstructionsSidebarLink/HideInstructionsSidebarLink';
import { LockSessionSidebarLink } from './components/LockSessionSidebarLink/LockSessionSidebarLink';
import { RankingSidebarLink } from './components/RankingSidebarLink/RankingSidebarLink';
import { SessionConfigSidebarLink } from './components/SessionConfigSidebarLink/SessionConfigSidebarLink';
import { ShowQrCodeSidebarLink } from './components/ShowQrCodeSidebarLink/ShowQrCodeSidebarLink';
import { useSessionClock } from './hooks/useSessionClock';
import {
  BottomContent,
  ContentWrapper,
  Separator,
  StyledBigSubtitle,
  StyledSmallTitle,
  TopContent,
} from './SettingsSidebar.styled';

interface SettingsSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SettingsSidebar = ({ isOpen, onClose }: SettingsSidebarProps) => {
  const t = useTranslate();
  const { client } = useHostClientContext();
  const { resultsModeConfig } = useHostGameContext();
  const sessionTime = useSessionClock(client.game.isStarted);

  return (
    <Sidebar isOpen={isOpen} onClose={onClose}>
      <ContentWrapper>
        <TopContent>
          <StyledBigSubtitle>{t('__new.play.shared.duration')}</StyledBigSubtitle>
          <StyledSmallTitle>{sessionTime}</StyledSmallTitle>
        </TopContent>

        <BottomContent>
          {resultsModeConfig.mode === 'ranking' && <RankingSidebarLink />}
          {resultsModeConfig.mode === 'analytics' && <AnalyticsResultsSidebarLink />}
          <DownloadResultsSidebarLink />
          <HideInstructionsSidebarLink />
          <ShowQrCodeSidebarLink />
          <LockSessionSidebarLink />
          <SessionConfigSidebarLink />
          <Separator />
          <EndSessionButton />
        </BottomContent>
      </ContentWrapper>
    </Sidebar>
  );
};
